module.exports = __webpack_public_path__ + "media/images/fiability-c0f7b580b446177c49f1d917ca520d8f.svg";